import { ReattemptButton } from "@/features/socratic/components/reattempt-button";
import { RecordingStartCutoffTip } from "@/features/socratic/components/recording-start-cutoff-tip";
import { useRecordingGate } from "@/features/socratic/hooks";

import { useAppSelector } from "@/data/hooks";

import {
  selectReattemptWindowEndDate,
  selectReattemptWindowEndDatePassed,
} from "../../socratic-slice";
import { ReattemptTimerTip } from "../reattempt-timer-tip";
import * as styles from "./reattempt-controls.css";

type Props = {
  onReattemptPressed: () => void;
  loading?: boolean;
  isReadonly?: boolean;
  numAttemptsRemaining: number;
};

export function ReattemptControls({
  onReattemptPressed,
  loading = false,
  isReadonly = false,
  numAttemptsRemaining,
}: Props) {
  const { hasAutoSubmission, wouldAutoSubmitDuringRecording } =
    useRecordingGate();
  const reattemptWindowEndDate = useAppSelector(selectReattemptWindowEndDate);
  const reattemptWindowEndDatePassed = useAppSelector(
    selectReattemptWindowEndDatePassed
  );

  const reattemptDisabled =
    loading ||
    numAttemptsRemaining === 0 ||
    reattemptWindowEndDatePassed === true ||
    wouldAutoSubmitDuringRecording ||
    isReadonly;

  // Show the recording start cutoff tip only if the user would be able to
  // reattempt within the allowed window
  const showRecordingStartCutoffTip =
    !isReadonly &&
    numAttemptsRemaining > 0 &&
    (reattemptWindowEndDate == null || reattemptWindowEndDatePassed === false);

  return (
    <div className={styles.root}>
      <ReattemptButton
        disabled={reattemptDisabled}
        onPress={onReattemptPressed}
        numAttemptsRemaining={numAttemptsRemaining}
      />
      {reattemptWindowEndDate != null &&
        numAttemptsRemaining > 0 &&
        !isReadonly && (
          <ReattemptTimerTip
            endDate={reattemptWindowEndDate}
            endDatePassed={reattemptWindowEndDatePassed === true}
          />
        )}
      {showRecordingStartCutoffTip && (
        <RecordingStartCutoffTip
          isFirstAttempt={false}
          hasAutoSubmission={hasAutoSubmission}
        />
      )}
    </div>
  );
}
